import clsx from "clsx";
import { Heading } from "components/common";
import Devider from "components/common/Devider/Devider";
import { IoClose } from "react-icons/io5";
import classes from "./Header.module.css";

const Header = ({ heading, onClose, className }) => {
  return (
    <div className={clsx(classes.header, className)}>
      <Heading primitive50 medium lg>
        {heading}
      </Heading>
      <button className={classes.closeButton} onClick={onClose}>
        <IoClose className={classes.closeIcon} />
      </button>
      <Devider />
    </div>
  );
};
export default Header;
